import {
  createSettingsParam,
  createStylesParam,
  SettingsParamType,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

export const settings = {
  newPostBoxLabel: createSettingsParam('newPostBoxLabel', {
    type: SettingsParamType.String,
    getDefaultValue: ({ t }) =>
      t('groups-web.discussion.create-post.placeholder'),
  }),
};

export const styles = {
  postsTitleColor: createStylesParam('postsTitleColor', {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  }),
  postsTitleFont: createStylesParam('postsTitleFont', {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16, htmlTag: 'h3' }),
  }),
  postsTextColor: createStylesParam('postsTextColor', {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  }),
  postsTextFont: createStylesParam('postsTextFont', {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  }),

  memberNameColor: createStylesParam('memberNameColor', {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  }),
  memberNameFont: createStylesParam('memberNameFont', {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  }),

  postingDateColor: createStylesParam('postingDateColor', {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  }),
  postingDateFont: createStylesParam('postingDateFont', {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 14 }),
  }),

  commentsReactionsCounterColor: createStylesParam(
    'commentsReactionsCounterColor',
    {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5'),
    },
  ),
  commentsReactionsCounterFont: createStylesParam(
    'commentsReactionsCounterFont',
    {
      type: StyleParamType.Font,
      getDefaultValue: wixFontParam('Body-M', { size: 14 }),
    },
  ),
};
